import { render, staticRenderFns } from "./Decoction.vue?vue&type=template&id=d8684e10&"
import script from "./Decoction.vue?vue&type=script&lang=js&"
export * from "./Decoction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports